import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArtAuthPods = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 420 300",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 210,
				y: 40,
				width: 16,
				height: 16,
				rx: 5,
				opacity: .22,
				transform: "rotate(-8 218 48)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 262,
				y: 96,
				width: 20,
				height: 20,
				rx: 6,
				opacity: .3,
				transform: "rotate(6 272 106)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 318,
				y: 30,
				width: 18,
				height: 18,
				rx: 5,
				opacity: .38,
				transform: "rotate(-5 327 39)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 350,
				y: 150,
				width: 26,
				height: 26,
				rx: 7,
				opacity: .5,
				transform: "rotate(5 363 163)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 236,
				y: 190,
				width: 16,
				height: 16,
				rx: 5,
				opacity: .25,
				transform: "rotate(7 244 198)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 372,
				y: 70,
				width: 24,
				height: 24,
				rx: 6,
				opacity: .55,
				transform: "rotate(-6 384 82)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				"data-pod": "",
				x: 300,
				y: 226,
				width: 22,
				height: 22,
				rx: 6,
				opacity: .42,
				transform: "rotate(-4 311 237)"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "rotate(4 313 165)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: 300,
					y: 152,
					width: 28,
					height: 28,
					rx: 7,
					opacity: .62
				}), /* @__PURE__ */ _jsx("rect", {
					x: 309,
					y: 158,
					width: 9,
					height: 15,
					rx: 2,
					fill: "var(--pure-white)"
				})]
			})
		]
	})
});
export default SvgArtAuthPods;
